import { __extends } from "tslib";
import { PostProcess } from "./postProcess";
import "../Shaders/highlights.fragment";
/**
 * Extracts highlights from the image
 * @see https://doc.babylonjs.com/how_to/how_to_use_postprocesses
 */
var HighlightsPostProcess = /** @class */ (function (_super) {
    __extends(HighlightsPostProcess, _super);
    /**
     * Extracts highlights from the image
     * @see https://doc.babylonjs.com/how_to/how_to_use_postprocesses
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of texture for the post process (default: Engine.TEXTURETYPE_UNSIGNED_INT)
     */
    function HighlightsPostProcess(name, options, camera, samplingMode, engine, reusable, textureType) {
        if (textureType === void 0) { textureType = 0; }
        return _super.call(this, name, "highlights", null, null, options, camera, samplingMode, engine, reusable, null, textureType) || this;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "HighlightsPostProcess" string
     */
    HighlightsPostProcess.prototype.getClassName = function () {
        return "HighlightsPostProcess";
    };
    return HighlightsPostProcess;
}(PostProcess));
export { HighlightsPostProcess };
//# sourceMappingURL=highlightsPostProcess.js.map